import { BookmarkViewModeTag } from '../models/bookmark-view-mode.enum';
import { BookmarkModel } from '../models/bookmark.model';

export function normalizeBookmarkModel(bookmark: BookmarkModel): BookmarkModel {
  const { id, type } = bookmark;
  // normalize id
  if (type === 'module') {
    bookmark.id = toAppContentId(id);
  }
  // normalize tag properties
  bookmark.tour = bookmark.tags.includes('tour');
  bookmark.animated = bookmark.tags.includes('animated');
  bookmark.quiz = bookmark.tags.includes('quiz');
  bookmark.lowDefinition = bookmark.tags.includes('low definition');

  // Determine viewMode, unless preset (which happens when using Preview)
  if (!bookmark.viewMode) {
    const viewModeTag = Object.values(BookmarkViewModeTag).find((value) =>
      bookmark.tags.includes(value),
    );

    bookmark.viewMode = viewModeTag ?? BookmarkViewModeTag.All;
  }

  return bookmark;
}

// Normalizes id to app formatted id (i.e., production/maleAdult/flu)
function toAppContentId(id: string): string {
  return id.replace('Condition.content.', '').replace('.json', '').split('.').join('/');
}
